import { useParams } from "react-router-dom";
import axios from "axios";
import { React, useEffect, useState, useMemo } from "react";
import {
  Layout,
  Card,
  Space,
  Collapse,
  Select,
  Image,
  Typography,
  Tooltip,
  Row,
  Flex,
  Col,
  FloatButton,
  Divider,
  Dropdown,
  Input,
  Modal,
  Table,
  message,
  Popover,
} from "antd/lib";
import {
  DownloadOutlined,
  ZoomInOutlined,
  ZoomOutOutlined,
  SyncOutlined,
  FileTextOutlined,
} from "@ant-design/icons";
import { ReactComponent as ClientLogo } from "./Assets/cm_logo.svg";
import { ReactComponent as CrdClientLogo } from "./Assets/crd_logo.svg";
import { ReactComponent as IconFail } from "./Assets/icon_fail.svg";
import { ReactComponent as IconOptionsArrow } from "./Assets/icon_optionsarrow.svg";
import { ReactComponent as IconPass } from "./Assets/icon_pass.svg";
import { ReactComponent as IconTestlink } from "./Assets/icon_testlink.svg";
import { ReactComponent as IconTitleArrowDown } from "./Assets/icon_title-arrowdown.svg";
import { ReactComponent as IconTitleArrowRight } from "./Assets/icon_title-arrowright.svg";
import { ReactComponent as IconView } from "./Assets/icon_view.svg";
import JSZip from "jszip";
import { saveAs } from "file-saver";
import {
  getBlobNames,
  downloadBlob,
  updateBaselineImageBlobStorage,
} from "./services/azureBlobService";
import "./App.css";

import LoadingSpinner from "./Components/loadingSpinner";
import HeaderComponent from "./Components/HeaderComponent";

import { ReactComponent as SmasiPictureMark } from "./Assets/smartsignals_Picturemark.svg";
import { ReactComponent as JiraPictureMark } from "./Assets/jira.svg";
import { Button } from "antd";
import ansiRegex from "ansi-regex";
const { Option } = Select;
const { Title, Text } = Typography;
const { TextArea } = Input;
const { Content } = Layout;
const client =
  window.location.host.startsWith("vw.") ||
  window.location.href.includes("client=vw") ||
  window.location.host.startsWith("pon.") ||
  window.location.href.includes("client=pon")
    ? "vw"
    : "cm";
const runMode = window.location.pathname.includes("/local")
  ? "LOCAL TESTS"
  : window.location.pathname.includes("/real-time")
    ? "CAMPAIGN MONITORING"
    : "DAILY RUN";

const onDownload = (imgUrl) => {
  fetch(imgUrl)
    .then((response) => response.blob())
    .then((blob) => {
      const url = URL.createObjectURL(new Blob([blob]));
      const link = document.createElement("a");
      link.href = url;
      link.download = imgUrl.replace(/.*screenshots\//, "").replace(/\//g, "+");
      document.body.appendChild(link);
      link.click();
      URL.revokeObjectURL(url);
      link.remove();
    });
};

const Collection = ({ path }) => {
  const { dynamicPath } = useParams();
  const collection =
    dynamicPath && dynamicPath.includes("local")
      ? dynamicPath.split("/")[0]
      : dynamicPath || window.location.pathname.includes("local")
        ? window.location.pathname.slice(1).split("/")[0]
        : window.location.pathname.slice(1);

  const [popoverVisible, setPopoverVisible] = useState(false);
  const togglePopover = () => {
    setPopoverVisible((prev) => !prev);
  };

  const [dataArr, setData] = useState(null);
  const [marketConfig, setMarketConfig] = useState(null);
  const [collectionsList, setCollectionsList] = useState([]);
  const [lastRun, setLastRun] = useState(null);
  const [excludedData, setExcludedData] = useState(null);
  const [selectedCampaigns, setSelectedCampaigns] = useState([]);
  const [selectedActions, setSelectedActions] = useState([]);
  const [selectedProducts, setSelectedProducts] = useState([]);
  const [selectedStatus, setSelectedStatus] = useState("");
  const [loading, setLoading] = useState(true);

  const [collapsed, setCollapsed] = useState(false);

  useEffect(() => {
    const fetchData = async () => {
      try {
        const response = await axios.get(
          `https://sdqareports.z6.web.core.windows.net/config/${client}/marketConfig.json`,
        );
        setMarketConfig(response.data);
      } catch (error) {
        console.error("Error fetching data:", error);
      }
    };
    fetchData();
  }, []);

  useEffect(() => {
    if (marketConfig !== null) {
      setCollectionsList(
        client === "cm"
          ? marketConfig["Nissan Motor Company"]
          : marketConfig["Volkswagen"],
      );
    }
  }, [marketConfig]);

  useEffect(() => {
    document.title = `QA Auditor | ${collection
      .toUpperCase()
      .replaceAll("/", " | ")}`;
    const fetchData = async () => {
      setLoading(true);
      try {
        const resultsPath = window.location.pathname.includes("/local")
          ? `${
              window.location.pathname
                .substring(window.location.pathname.indexOf("/local"))
                .endsWith("/")
                ? `${window.location.pathname
                    .substring(window.location.pathname.indexOf("/local"))
                    .splice(0, -1)}`
                : `${window.location.pathname.substring(
                    window.location.pathname.indexOf("/local"),
                  )}`
            }/results_v2.json`
          : `${collection}/results_v2.json`;
        const resultsUrl = window.location.pathname.includes("/local")
          ? `https://sdqareports.z6.web.core.windows.net/${collection}${resultsPath}`.toLowerCase()
          : `https://sdqareports.z6.web.core.windows.net/${resultsPath}`.toLowerCase();

        const response = await fetch(resultsUrl, {
          cache: "no-cache",
        });
        const data = await response.json();

        var excludedData;
        const excludedDataResponse = await fetch(
          `https://sdqareports.z6.web.core.windows.net/${collection}/notCoveredActions.json`,
          {
            cache: "no-cache",
          },
        );
        if (!excludedDataResponse.ok) {
          if (excludedDataResponse.status === 404) excludedData = [];
        } else excludedData = await excludedDataResponse.json();
        setData(data.results);
        setLastRun(data.startTime);
        setExcludedData(excludedData);
      } catch (error) {
        setLoading(false);
        console.error("Error fetching data");
      } finally {
        setLoading(false);
      }
    };
    if (collection) {
      fetchData();
    }
  }, [collection]);

  const uniqueCampaigns = useMemo(() => {
    if (dataArr && dataArr.length > 0) {
      const uniqueCampaigns = [
        ...new Set(dataArr.map((item) => item.campaign)),
      ];

      return uniqueCampaigns;
    } else return [];
  });
  const uniqueActions = useMemo(() => {
    if (dataArr && dataArr.length > 0) {
      const uniqueActions = [...new Set(dataArr.map((item) => item.action))];

      return uniqueActions;
    } else return [];
  });
  const uniqueProducts = useMemo(() => {
    if (dataArr && dataArr.length > 0) {
      const uniqueProducts = [...new Set(dataArr.map((item) => item.product))];

      return uniqueProducts;
    } else return [];
  });

  const filteredCampaigns = useMemo(() => {
    if (dataArr && dataArr.length > 0) {
      return dataArr
        .filter((item) => {
          const actionMatch =
            selectedActions.length === 0 ||
            selectedActions.includes(item.action);
          const productMatch =
            selectedProducts.length === 0 ||
            selectedProducts.includes(item.product);
          const statusMatch =
            selectedStatus === "" ||
            (selectedStatus === "Pass" && item.status === "passed") ||
            (selectedStatus === "Fail" &&
              (item.status === "failed" || item.status === "timedOut"));
          return actionMatch && productMatch && statusMatch;
        })
        .map((item) => item.campaign);
    } else return [];
  }, [dataArr, selectedActions, selectedProducts, selectedStatus]);

  const filteredActions = useMemo(() => {
    if (dataArr && dataArr.length > 0) {
      return dataArr
        .filter((item) => {
          const campaignMatch =
            selectedCampaigns.length === 0 ||
            selectedCampaigns.includes(item.campaign);
          const productMatch =
            selectedProducts.length === 0 ||
            selectedProducts.includes(item.product);
          const statusMatch =
            selectedStatus === "" ||
            (selectedStatus === "Pass" && item.status === "passed") ||
            (selectedStatus === "Fail" &&
              (item.status === "failed" || item.status === "timedOut"));
          return campaignMatch && productMatch && statusMatch;
        })
        .map((item) => item.action);
    } else return [];
  }, [dataArr, selectedCampaigns, selectedProducts, selectedStatus]);

  const filteredProducts = useMemo(() => {
    if (dataArr && dataArr.length > 0) {
      return dataArr
        .filter((item) => {
          const campaignMatch =
            selectedCampaigns.length === 0 ||
            selectedCampaigns.includes(item.campaign);
          const actionMatch =
            selectedActions.length === 0 ||
            selectedActions.includes(item.action);
          const statusMatch =
            selectedStatus === "" ||
            (selectedStatus === "Pass" && item.status === "passed") ||
            (selectedStatus === "Fail" &&
              (item.status === "failed" || item.status === "timedOut"));
          return campaignMatch && actionMatch && statusMatch;
        })
        .map((item) => item.product);
    } else return [];
  }, [dataArr, selectedCampaigns, selectedActions, selectedStatus]);

  const filteredData = useMemo(() => {
    if (dataArr && dataArr.length > 0) {
      return dataArr.filter((item) => {
        const campaignMatch =
          selectedCampaigns.length === 0 ||
          selectedCampaigns.includes(item.campaign);
        const actionMatch =
          selectedActions.length === 0 || selectedActions.includes(item.action);
        const productMatch =
          selectedProducts.length === 0 ||
          selectedProducts.includes(item.product);
        const statusMatch =
          selectedStatus === "" ||
          (selectedStatus === "Pass" && item.status === "passed") ||
          (selectedStatus === "Fail" &&
            (item.status === "failed" || item.status === "timedOut"));
        return campaignMatch && actionMatch && productMatch && statusMatch;
      });
    } else return [];
  }, [
    dataArr,
    selectedCampaigns,
    selectedActions,
    selectedProducts,
    selectedStatus,
  ]);

  const decodeHtml = (encodedString) => {
    const textArea = document.createElement("textarea");
    textArea.innerHTML = encodedString;
    return textArea.value;
  };

  const ansiEscapePattern = new RegExp(
    [
      "[\\u001b\\u009b][[\\]()#;?]*(?:",
      "(?:[a-zA-Z\\d]*(?:;[a-zA-Z\\d]*)*)?[\\dA-PR-TZcf-nq-uy=><~]", // ANSI sequences
      "|[\\dA-PR-TZcf-nq-uy=><~]", // Control characters
      ")",
    ].join("|"),
    "g",
  );

  // function cleanAnsiString(input) {
  //   // Replace any ANSI escape sequences with an empty string
  //   return input.replace(ansiRegex(), "");
  // }

  // const stripAnsi = (str) =>
  //   str.replace(ansiEscapePattern, "").replace(/\d+[A-Za-z]/g, "");

  function cleanAnsiString(str) {
    // Regular expression to remove ANSI escape codes
    const ansiRegex = /\x1B\[([0-9;]*[A-Za-z])/g;

    // Replace ANSI escape sequences with an empty string
    let cleanedString = str.replace(ansiRegex, "");

    // Normalize newlines to actual line breaks
    cleanedString = cleanedString.replace(/\n/g, "<br />"); // React will render <br /> correctly

    return cleanedString;
  }

  const [isModalOpen, setIsModalOpen] = useState(false);
  const showExclusionModal = () => {
    setIsModalOpen(true);
  };

  const handleCancel = () => {
    setIsModalOpen(false);
  };
  const containerName = "$web";
  const screenshotsFolderPath = `${collection}/screenshots/`;
  const handleDownloadAllAsZip = async () => {
    const loadingMessageKey = "loading";
    try {
      // message.error({ content: "Coming soon!", key: "loading" });
      message.loading({
        style: { fontFamily: `${client}Regular` },
        content: "Fetching screenshots list...",
        key: loadingMessageKey,
      });

      const blobNames = await getBlobNames(
        containerName,
        screenshotsFolderPath,
      );
      const totalFiles = blobNames.length;
      if (totalFiles === 0) {
        message.info({
          style: { fontFamily: `${client}Regular` },
          content: "No files found to download.",
          key: loadingMessageKey,
        });
        return;
      }

      const zip = new JSZip();
      message.loading({
        style: { fontFamily: `${client}Regular` },
        content: "Downloading files...",
        key: loadingMessageKey,
      });

      for (let i = 0; i < totalFiles; i++) {
        const blobName = blobNames[i];
        message.loading({
          style: { fontFamily: `${client}Regular` },
          content: `Downloading & Zipping files...(${i + 1} of ${totalFiles})`,
          key: loadingMessageKey,
          duration: 0,
        });
        const blob = await downloadBlob(containerName, blobName);
        zip.file(blobName, blob);
      }

      const zipBlob = await zip.generateAsync({ type: "blob" });
      saveAs(zipBlob, "screenshots.zip");
      message.success({
        content: "Download complete!",
        key: loadingMessageKey,
        duration: 5,
      });
    } catch (error) {
      console.error("Screenshots download error : ", error);
      message.error({ content: "Failed to download", key: "loading" });
    }
  };

  const updateBaselineImage = async (url) => {
    const newBaseline = `${collection}/screenshots/baseline/${url
      .split("/")
      [url.split("/").length - 1].replace("-actual", "")}`;

    await updateBaselineImageBlobStorage(containerName, url, newBaseline);
  };

  const items = [
    {
      label: (
        <a
          style={{ fontFamily: `${client}Regular` }}
          onClick={handleDownloadAllAsZip}
        >
          Download all screenshots
        </a>
      ),
      key: "0",
    },
    {
      label: (
        <a
          style={{ fontFamily: `${client}Regular` }}
          onClick={showExclusionModal}
        >
          Excluded list
        </a>
      ),
      key: "1",
    },
  ];

  const columns = [
    {
      title: "Campaign",
      dataIndex: "campaign",
      key: "campaign",
    },
    {
      title: "Action",
      dataIndex: "action",
      key: "action",
      render: (text, record) => (
        <a
          href={record.actionLink}
          style={{ color: "#69b1ff" }}
          target="_blank"
          rel="noopener noreferrer"
        >
          {record.action}
        </a>
      ),
    },
  ];

  if (loading) return <LoadingSpinner />;

  return (
    <div>
      <div>
        <Layout className="layout">
          <HeaderComponent collectionsList={collectionsList} />
          <Content
            style={{
              overflowY: "auto",
              height: "calc(100vh-64px)",
              //background: client === "vw" ? "#F8F5F2" : "#F7FAF2",
              background: "#F7FAF2",
              marginBottom: "2rem",
            }}
          >
            <div style={{ padding: "0 4vh" }}>
              <Row
                justify="space-between"
                align="middle"
                style={{ marginTop: "1.8rem" }}
              >
                <Col>
                  <Text
                    strong
                    style={{
                      fontFamily: `${client}Compact`,
                      fontSize: client === "vw" ? "3.167rem" : "4.167rem",
                      lineHeight: "0.75",
                    }}
                  >
                    {runMode.toUpperCase()} - RESULTS DETAILS
                  </Text>
                </Col>
                <Col>
                  {client === "cm" && (
                    <ClientLogo
                      style={{
                        marginTop: "12px",
                        height: "2rem",
                      }}
                    />
                  )}
                  {client === "vw" && (
                    <CrdClientLogo
                      style={{
                        marginTop: "12px",
                        height: "2.6rem",
                      }}
                    />
                  )}
                </Col>
              </Row>
              <Row>
                <Col
                // span={12}
                // flex="auto"
                // style={{ textAlign: "start", padding: "0 6vh" }}
                >
                  <Text
                    strong
                    style={{
                      fontFamily: `${client}Bold`,
                      fontSize: "1.667rem",
                    }}
                  >
                    {collection.toUpperCase().replaceAll("/", " | ")}
                  </Text>
                </Col>
              </Row>
              {/* <Row
              align="middle"
              style={{
                background: "#fff",
                padding: "0.8rem 0px",
                borderRadius: "5px",
                marginBottom: "20px",
              }}
            >
              <Col flex="20px">
                <MenuToggle
                  bannerTitle=""
                  drawerTitle="Menu"
                  allCollections={collectionsList}
                />
              </Col>
              <Col flex="20px">
                <Tooltip title="Back">
                  <Button
                    type="text"
                    style={{ marginLeft: "1rem" }}
                    icon={
                      <ArrowLeftOutlined
                        style={{
                          fontSize: "1.4rem",
                          color: "#000",
                          padding: "0.5rem 1.5rem",
                        }}
                      ></ArrowLeftOutlined>
                    }
                    ghost
                    href="/"
                  />
                </Tooltip>
              </Col>
              <Col flex="100px" style={{ textAlign: "center" }}>
                <Text style={{ fontSize: "1rem" }}>
                  {collection.toUpperCase()}
                </Text>
              </Col>
              <Col flex="auto" style={{ textAlign: "center" }}>
                <Text strong style={{ fontSize: "1.4rem" }}>
                  Daily run - Results Details
                </Text>
              </Col>

              <Col flex="140px" style={{ textAlign: "end" }}>
                <UserMenu />
              </Col>
            </Row> */}

              <div
                style={{
                  display: "flex",
                  justifyContent: "flex-end",
                  marginBottom: "0.6rem",
                }}
              >
                <Text
                  style={{
                    fontFamily: `${client}Slanted`,
                    fontSize: "0.889rem",
                  }}
                >
                  Last run:{" "}
                  {new Date(lastRun).toString().split("GMT")[0].trim()}
                </Text>
                <Popover
                  overlayInnerStyle={{
                    fontFamily: `${client}Regular`,
                  }}
                  content={
                    <p>
                      Check runtime to ensure that the test has been running
                      today as expected.
                    </p>
                  }
                  // title="Popover Title"
                  trigger="click"
                  placement="topRight"
                  overlayStyle={{
                    maxWidth: 300,
                  }}
                  overlayClassName="tutorialPopover"
                  open={popoverVisible}
                  onOpenChange={(visible) => setPopoverVisible(visible)}
                />
              </div>
              <div style={{ display: "flex", justifyContent: "flex-end" }}>
                <Dropdown
                  menu={{
                    items,
                  }}
                >
                  <a onClick={(e) => e.preventDefault()}>
                    <Space
                      style={{
                        fontFamily: `${client}Bold`,
                        fontSize: "0.889rem",
                      }}
                    >
                      Options
                      <IconOptionsArrow style={{ width: "0.6rem" }} />
                    </Space>
                    <Popover
                      overlayInnerStyle={{
                        fontFamily: `${client}Regular`,
                      }}
                      content={
                        <p>
                          Options will give you the option to download all
                          screenshots as well as see which actions may not be
                          included in the testing.
                        </p>
                      }
                      // title="Popover Title"
                      trigger="click"
                      placement="bottomRight"
                      overlayStyle={{
                        maxWidth: 300,
                      }}
                      overlayClassName="tutorialPopover"
                      open={popoverVisible}
                      onOpenChange={(visible) => setPopoverVisible(visible)}
                    />
                  </a>
                </Dropdown>
              </div>
              <Row gutter={20} style={{ marginTop: "1rem" }}>
                <Col className="gutter-row" span={6}>
                  <Popover
                    overlayInnerStyle={{
                      fontFamily: `${client}Regular`,
                    }}
                    content={
                      <p>
                        Test results can be filtered by campaign, action,
                        product and status.
                      </p>
                    }
                    // title="Popover Title"
                    trigger="click"
                    placement="topRight"
                    open={popoverVisible}
                    overlayStyle={{
                      maxWidth: 300,
                    }}
                    overlayClassName="tutorialPopover"
                    onOpenChange={(visible) => setPopoverVisible(visible)}
                  />
                  <Title
                    level={5}
                    style={{
                      fontFamily: `${client}Bold`,
                      fontSize: "0.944rem",
                    }}
                  >
                    Campaign
                  </Title>
                  <Select
                    mode="multiple"
                    // defaultValue={}
                    placeholder="All"
                    style={{ flex: 1, width: "20vw" }}
                    dropdownStyle={{
                      fontFamily: `${client}Regular`,
                      fontSize: "0.944rem",
                    }}
                    onChange={setSelectedCampaigns}
                    value={selectedCampaigns}
                  >
                    {uniqueCampaigns
                      .filter((campaign) =>
                        filteredCampaigns.includes(campaign),
                      )
                      .map((campaign, index) => (
                        <Option key={campaign} value={campaign}>
                          {campaign}
                        </Option>
                      ))}
                  </Select>
                </Col>
                <Col className="gutter-row" span={6}>
                  <Title
                    level={5}
                    style={{
                      fontFamily: `${client}Bold`,
                      fontSize: "0.944rem",
                    }}
                  >
                    Action
                  </Title>
                  <Select
                    mode="multiple"
                    // defaultValue={}
                    placeholder="All"
                    style={{ flex: 1, width: "20vw" }}
                    dropdownStyle={{
                      fontFamily: `${client}Regular`,
                      fontSize: "0.944rem",
                    }}
                    onChange={setSelectedActions}
                    value={selectedActions}
                  >
                    {uniqueActions
                      .filter((action) => filteredActions.includes(action))
                      .map((action) => (
                        <Option key={action} value={action}>
                          {action}
                        </Option>
                      ))}
                  </Select>
                </Col>
                <Col className="gutter-row" span={6}>
                  <Title
                    level={5}
                    style={{
                      fontFamily: `${client}Bold`,
                      fontSize: "0.944rem",
                    }}
                  >
                    Product
                  </Title>
                  <Select
                    mode="multiple"
                    // defaultValue={}
                    placeholder="All"
                    style={{ flex: 1, width: "20vw" }}
                    dropdownStyle={{
                      fontFamily: `${client}Regular`,
                      fontSize: "0.944rem",
                    }}
                    onChange={setSelectedProducts}
                    value={selectedProducts}
                  >
                    {uniqueProducts
                      .filter((product) => filteredProducts.includes(product))
                      .map((product) => (
                        <Option key={product} value={product}>
                          {product}
                        </Option>
                      ))}
                  </Select>
                </Col>
                <Col className="gutter-row" span={6}>
                  <Popover
                    overlayInnerStyle={{
                      fontFamily: `${client}Regular`,
                    }}
                    content={
                      <p>
                        Choose Status „Failed“ to see all failed tests at one
                        glance.
                      </p>
                    }
                    // title="Popover Title"
                    trigger="click"
                    placement="topRight"
                    open={popoverVisible}
                    overlayStyle={{
                      maxWidth: 300,
                    }}
                    overlayClassName="tutorialPopover"
                    onOpenChange={(visible) => setPopoverVisible(visible)}
                  />
                  <Title
                    level={5}
                    style={{
                      fontFamily: `${client}Bold`,
                      fontSize: "0.944rem",
                    }}
                  >
                    Status
                  </Title>
                  <Select
                    placeholder="All"
                    style={{ flex: 1, width: "20vw" }}
                    dropdownStyle={{
                      fontFamily: `${client}Regular`,
                      fontSize: "0.944rem",
                    }}
                    onChange={setSelectedStatus}
                    value={selectedStatus}
                  >
                    <Option value="">All</Option>
                    <Option value="Pass">Pass</Option>
                    <Option value="Fail">Fail</Option>
                  </Select>
                </Col>
              </Row>

              <Space
                direction="horizontal"
                size="middle"
                style={{
                  display: "grid",
                  rowGap: "0.4rem",
                  marginTop: "2rem",
                }}
              >
                {filteredData.map((obj, index) => (
                  <>
                    <Collapse
                      ghost
                      expandIcon={({ isActive }) =>
                        isActive ? (
                          <IconTitleArrowDown width={12} />
                        ) : (
                          <IconTitleArrowRight width={8} />
                        )
                      }
                      key={{ index }}
                      className="campaignCard"
                      defaultActiveKey={
                        collection === "vwusa"
                          ? obj.campaign
                          : index === 0
                            ? obj.campaign
                            : []
                      }
                      items={[
                        {
                          key: obj.campaign + "_" + index,
                          label:
                            obj.language !== undefined ? (
                              <div>
                                <Text
                                  style={{
                                    fontFamily: `${client}Bold`,
                                    fontSize: "1.167rem",
                                  }}
                                >
                                  Campaign: {obj.campaign}
                                </Text>
                                <Divider
                                  type="vertical"
                                  className="titleDivider"
                                ></Divider>
                                <Text
                                  style={{
                                    fontFamily: `${client}Bold`,
                                    fontSize: "1.167rem",
                                  }}
                                >
                                  Action: {obj.action}
                                </Text>
                                <Divider
                                  type="vertical"
                                  className="titleDivider"
                                ></Divider>
                                <Text
                                  style={{
                                    fontFamily: `${client}Bold`,
                                    fontSize: "1.167rem",
                                  }}
                                >
                                  Product: {obj.product}
                                </Text>
                                <Divider
                                  type="vertical"
                                  className="titleDivider"
                                ></Divider>
                                <Text
                                  style={{
                                    fontFamily: `${client}Bold`,
                                    fontSize: "1.167rem",
                                  }}
                                >
                                  Language: {obj.language}
                                </Text>
                                {index === 0 && (
                                  <Popover
                                    overlayInnerStyle={{
                                      fontFamily: `${client}Regular`,
                                    }}
                                    content={
                                      <p>
                                        Name of the tested campaign, action,
                                        product and language.
                                      </p>
                                    }
                                    // title="Popover Title"
                                    trigger="click"
                                    placement="rightBottom"
                                    overlayStyle={{
                                      maxWidth: 500,
                                    }}
                                    overlayClassName="tutorialPopover"
                                    open={popoverVisible}
                                    onOpenChange={(visible) =>
                                      setPopoverVisible(visible)
                                    }
                                  />
                                )}
                              </div>
                            ) : (
                              <div>
                                <Text
                                  style={{
                                    fontFamily: `${client}Bold`,
                                    fontSize: "1.167rem",
                                  }}
                                >
                                  Campaign: {obj.campaign}
                                </Text>
                                <Divider
                                  type="vertical"
                                  className="titleDivider"
                                ></Divider>
                                <Text
                                  style={{
                                    fontFamily: `${client}Bold`,
                                    fontSize: "1.167rem",
                                  }}
                                >
                                  Action: {obj.action}
                                </Text>
                                <Divider
                                  type="vertical"
                                  className="titleDivider"
                                ></Divider>
                                <Text
                                  style={{
                                    fontFamily: `${client}Bold`,
                                    fontSize: "1.167rem",
                                  }}
                                >
                                  Product: {obj.product}
                                </Text>
                                {index === 0 && (
                                  <Popover
                                    overlayInnerStyle={{
                                      fontFamily: `${client}Regular`,
                                    }}
                                    content={
                                      <p>
                                        Name of the tested campaign, action and
                                        product.
                                      </p>
                                    }
                                    // title="Popover Title"
                                    trigger="click"
                                    placement="rightBottom"
                                    overlayStyle={{
                                      maxWidth: 300,
                                    }}
                                    overlayClassName="tutorialPopover"
                                    open={popoverVisible}
                                    onOpenChange={(visible) =>
                                      setPopoverVisible(visible)
                                    }
                                  />
                                )}
                              </div>
                            ),
                          extra: (
                            <>
                              <Row
                                gutter={16}
                                style={{
                                  display: "flex",
                                  alignItems: "flex-end",
                                  justifyContent: "space-evenly",
                                  marginRight: "1rem",
                                }}
                              >
                                {obj.status === "failed" &&
                                  client !== "cm" &&
                                  !collection.match(/nis|inf/) &&
                                  !window.location.pathname.includes(
                                    "local",
                                  ) && (
                                    <Col span={4}>
                                      <Tooltip title="Open JIRA">
                                        <Button
                                          type="text"
                                          icon={
                                            <JiraPictureMark
                                              width={"2rem"}
                                              style={{
                                                fontSize: "2rem",
                                              }}
                                            />
                                          }
                                          ghost
                                          href={`https://mysmartdigital.atlassian.net/issues/?jql=parent%20%3D%20VWPER-5543%20and%20summary%20~%20"%5C"${collection.toUpperCase()}%20%7C%20Campaign%20%3A%20${
                                            obj.campaign
                                          }%20%7C%20Action%20%3A%20${
                                            obj.action
                                          }%5C""%20order%20by%20created%20DESC`}
                                          target="_blank"
                                        />
                                      </Tooltip>
                                    </Col>
                                  )}
                                {
                                  <Col span={4}>
                                    <Tooltip title="Test link">
                                      <Button
                                        type="text"
                                        icon={
                                          <IconTestlink
                                            width={"2rem"}
                                            style={{
                                              fontSize: "2rem",
                                            }}
                                          />
                                        }
                                        ghost
                                        href={atob(
                                          obj.attachments.filter(
                                            (item) => item.name === "Test link",
                                          )[0].body,
                                        )}
                                        target="_blank"
                                      />
                                    </Tooltip>
                                  </Col>
                                }
                                {
                                  <Col span={4}>
                                    <Tooltip title="Open SmaSi">
                                      <Button
                                        type="text"
                                        icon={
                                          <SmasiPictureMark
                                            width={"1.8rem"}
                                            style={{
                                              fontSize: "1.8rem",
                                            }}
                                          />
                                        }
                                        ghost
                                        href={atob(
                                          obj.attachments.filter(
                                            (item) => item.name === "Action",
                                          )[0].body,
                                        )}
                                        target="_blank"
                                      />
                                    </Tooltip>
                                  </Col>
                                }

                                {obj.status === "passed" ? (
                                  <Col span={4}>
                                    <Tooltip title="Pass">
                                      <Button
                                        type="text"
                                        icon={
                                          <IconPass
                                            width={"2rem"}
                                            style={{
                                              fontSize: "2rem",
                                              color:
                                                client === "vw"
                                                  ? "#007B55"
                                                  : "#33c",
                                            }}
                                          />
                                        }
                                        ghost
                                      />
                                    </Tooltip>
                                  </Col>
                                ) : (
                                  <Col span={4}>
                                    <Tooltip title="Fail">
                                      <Button
                                        type="text"
                                        icon={
                                          <IconFail
                                            width={"2rem"}
                                            style={{
                                              color: "red",
                                              fontSize: "2rem",
                                            }}
                                          />
                                        }
                                        ghost
                                      />
                                    </Tooltip>
                                  </Col>
                                )}
                              </Row>
                            </>
                          ),
                          children: (
                            <>
                              {obj.attachments.some((attachment) =>
                                attachment.name.includes("Screenshot"),
                              ) && (
                                <Card
                                  size="small"
                                  type="inner"
                                  className="attachmentsCard"
                                  title="Screenshots"
                                  styles={{
                                    header: {
                                      background: "#F7FAF2",
                                      padding: "0",
                                    },
                                    body: {
                                      background:
                                        client === "vw"
                                          ? "#D4E2F1BF"
                                          : "#D6E6F8",
                                    },
                                  }}
                                  style={{
                                    fontFamily: `${client}Bold`,
                                    fontSize: "1.111rem",
                                    border: "transparent",
                                    borderRadius: "0",
                                  }}
                                >
                                  <Flex wrap gap="small">
                                    <Image.PreviewGroup
                                      preview={{
                                        countRender: (current) => null,
                                        toolbarRender: (
                                          _,
                                          {
                                            image: { url },
                                            transform: { scale },
                                            actions: { onZoomOut, onZoomIn },
                                          },
                                        ) => (
                                          <Space
                                            size={12}
                                            className="toolbar-wrapper"
                                          >
                                            <Tooltip title="Download">
                                              <DownloadOutlined
                                                onClick={() => onDownload(url)}
                                                label="Download"
                                              />
                                            </Tooltip>
                                            <Tooltip title="Zoom out">
                                              <ZoomOutOutlined
                                                disabled={scale === 1}
                                                onClick={onZoomOut}
                                              />
                                            </Tooltip>
                                            <Tooltip title="Zoom in">
                                              <ZoomInOutlined
                                                disabled={scale === 50}
                                                onClick={onZoomIn}
                                              />
                                            </Tooltip>
                                            <Tooltip title="Update as Baseline image">
                                              <SyncOutlined
                                                disabled={
                                                  url.includes("comparison") &&
                                                  url.includes("actual")
                                                    ? false
                                                    : true
                                                }
                                                onClick={() => {
                                                  try {
                                                    updateBaselineImage(url);
                                                    message.success(
                                                      `Baseline image updated!`,
                                                    );
                                                  } catch (error) {
                                                    message.error(
                                                      `Failed to update baseline image`,
                                                    );
                                                  }
                                                }}
                                              />
                                            </Tooltip>
                                          </Space>
                                        ),
                                      }}
                                    >
                                      {obj.attachments
                                        .filter((item) =>
                                          item.name.includes("Screenshot"),
                                        )
                                        .map((attachment, index) => (
                                          <div
                                            key={index}
                                            className="imageCard"
                                          >
                                            <Space direction="vertical">
                                              <Text
                                                style={{
                                                  fontFamily: `${client}Regular`,
                                                  fontSize: "0.944rem",
                                                }}
                                              >
                                                {attachment.name.replace(
                                                  "Screenshot - ",
                                                  "",
                                                )}
                                              </Text>
                                              {index === 0 && (
                                                <Popover
                                                  overlayInnerStyle={{
                                                    fontFamily: `${client}Regular`,
                                                  }}
                                                  content={
                                                    <p>
                                                      Screenshots of tested
                                                      visual on product page.
                                                      Click to go in gallery
                                                      mode.
                                                    </p>
                                                  }
                                                  // title="Popover Title"
                                                  trigger="click"
                                                  placement="topRight"
                                                  overlayStyle={{
                                                    maxWidth: 300,
                                                  }}
                                                  overlayClassName="tutorialPopover"
                                                  open={popoverVisible}
                                                  onOpenChange={(visible) =>
                                                    setPopoverVisible(visible)
                                                  }
                                                />
                                              )}
                                              {index !== 0 && <div></div>}
                                              <Image
                                                loading="lazy"
                                                key={index}
                                                alt={attachment.name}
                                                width={150}
                                                height={150}
                                                preview={{
                                                  mask: (
                                                    <IconView
                                                      width={24}
                                                      height={24}
                                                      style={{
                                                        bottom: 0,
                                                        visibility: "visible",
                                                        opacity: 1,
                                                      }}
                                                    />
                                                  ),
                                                }}
                                                style={{
                                                  backgroundColor:
                                                    "transparent",
                                                  objectFit:
                                                    attachment.name.includes(
                                                      "Fullpage",
                                                    )
                                                      ? "cover"
                                                      : "contain",
                                                }}
                                                src={atob(attachment.body)}
                                              />
                                            </Space>
                                          </div>
                                        ))}
                                    </Image.PreviewGroup>
                                  </Flex>
                                </Card>
                              )}
                              {obj.attachments.some((attachment) =>
                                attachment.name.includes("Test log"),
                              ) && (
                                <Card
                                  size="small"
                                  type="inner"
                                  className="attachmentsCard"
                                  title="Test log"
                                  styles={{
                                    header: {
                                      background: "#F7FAF2",
                                      padding: "0",
                                    },
                                    body: {
                                      background:
                                        client === "vw"
                                          ? "#D4E2F1BF"
                                          : "#D6E6F8",
                                    },
                                  }}
                                  style={{
                                    fontFamily: `${client}Bold`,
                                    fontSize: "1.111rem",
                                    border: "transparent",
                                    borderRadius: "0",
                                  }}
                                >
                                  <Row gutter={4}>
                                    <Space direction="vertical">
                                      {obj.attachments
                                        .filter((item) =>
                                          item.name.includes("Test log"),
                                        )
                                        .map((attachment, index) => (
                                          <Text
                                            style={{
                                              fontFamily: `${client}Regular`,
                                              fontSize: "1rem",
                                              lineHeight: "0.8rem",
                                            }}
                                          >
                                            •{" "}
                                            {decodeHtml(atob(attachment.body))}
                                            {index === 0 && (
                                              <Popover
                                                overlayInnerStyle={{
                                                  fontFamily: `${client}Regular`,
                                                }}
                                                content={
                                                  <p>
                                                    Summary of test steps &
                                                    results.
                                                  </p>
                                                }
                                                // title="Popover Title"
                                                trigger="click"
                                                placement="right"
                                                overlayStyle={{
                                                  maxWidth: 400,
                                                }}
                                                overlayClassName="tutorialPopover"
                                                open={popoverVisible}
                                                onOpenChange={(visible) =>
                                                  setPopoverVisible(visible)
                                                }
                                              />
                                            )}
                                          </Text>
                                        ))}
                                      {obj.errorMessage && (
                                        <div>
                                          <Divider></Divider>
                                          <Text
                                            key={index}
                                            style={{
                                              fontFamily: `${client}Regular`,
                                              fontSize: "1rem",
                                              // lineHeight: "0.5rem",
                                              color: "red",
                                            }}
                                          >
                                            Error message:
                                          </Text>
                                          <Popover
                                            overlayInnerStyle={{
                                              fontFamily: `${client}Regular`,
                                            }}
                                            content={
                                              <p>Error message details.</p>
                                            }
                                            // title="Popover Title"
                                            trigger="click"
                                            placement="right"
                                            overlayStyle={{
                                              maxWidth: 400,
                                            }}
                                            overlayClassName="tutorialPopover"
                                            open={popoverVisible}
                                            onOpenChange={(visible) =>
                                              setPopoverVisible(visible)
                                            }
                                          />
                                          <br></br>
                                          {obj.errorMessage.map(
                                            (part, index) => (
                                              <>
                                                {part.text &&
                                                  part.text.replaceAll(
                                                    "\n",
                                                    "",
                                                  ) !== "" &&
                                                  part.color &&
                                                  part.color !== "yellow" && (
                                                    // part.text !== "\n"
                                                    <>
                                                      <Text
                                                        key={index}
                                                        style={{
                                                          fontFamily: `${client}Regular`,
                                                          fontSize: "0.75rem",
                                                          lineHeight: "0.5rem",
                                                          // color: "red",
                                                        }}
                                                      >
                                                        <span
                                                          style={{
                                                            color: part.color,
                                                          }}
                                                        >
                                                          {part.text}
                                                        </span>
                                                      </Text>
                                                      <br />
                                                    </>
                                                  )}
                                              </>
                                            ),
                                          )}
                                        </div>
                                        // <Text
                                        // style={{
                                        //   fontFamily: `${client}Regular`,
                                        //   fontSize: "1rem",
                                        //   lineHeight: "0.8rem",
                                        //   color: "red",
                                        // }}
                                        // >
                                        //   Error :{" "}
                                        //   {
                                        //     obj.errorMessage
                                        //     // .replace("Error: ", "")
                                        //     // .replace("\n", " ")
                                        //     // .replace(/\u001b\[31m/g, "")
                                        //     // .replace(/\u001b\[39m/g, "")
                                        //   }
                                        // </Text>
                                      )}
                                    </Space>
                                    {/* <Space direction="vertical">
                                      {obj.attachments
                                        .filter((item) =>
                                          item.name.includes("Test log")
                                        )
                                        .map((attachment, index) => (
                                          <Text
                                            style={{
                                              fontFamily: `${client}Regular`,
                                              fontSize: "1rem",
                                              lineHeight: "0.8rem",
                                            }}
                                          >
                                            •{" "}
                                            {decodeHtml(atob(attachment.body))}
                                            {index === 0 && (
                                              <Popover
                                                overlayInnerStyle={{
                                                  fontFamily: `${client}Regular`,
                                                }}
                                                content={
                                                  <p>
                                                    Summary of test steps &
                                                    results.
                                                  </p>
                                                }
                                                // title="Popover Title"
                                                trigger="click"
                                                placement="right"
                                                overlayStyle={{
                                                  maxWidth: 400,
                                                }}
                                                overlayClassName="tutorialPopover"
                                                open={popoverVisible}
                                                onOpenChange={(visible) =>
                                                  setPopoverVisible(visible)
                                                }
                                              />
                                            )}
                                          </Text>
                                        ))}
                                      {obj.errorMessage && (
                                        <>
                                          <Text
                                            style={{
                                              lineHeight: "0.8rem",
                                              color: "red",
                                            }}
                                          >
                                            Error :{" "}
                                            {
                                              cleanAnsiString(obj.errorMessage)
                                                .replace("Error: ", "")
                                                .replace("\n", " ")
                                              // .replace(/\u001b\[31m/g, "")
                                              // .replace(/\u001b\[39m/g, "")
                                            }
                                            <Popover
                                              overlayInnerStyle={{
                                                fontFamily: `${client}Regular`,
                                              }}
                                              content={
                                                <p>
                                                  The error message will inform
                                                  you why the test has failed.
                                                </p>
                                              }
                                              // title="Popover Title"
                                              trigger="click"
                                              placement="right"
                                              overlayStyle={{
                                                maxWidth: 500,
                                              }}
                                              overlayClassName="tutorialPopover"
                                              open={popoverVisible}
                                              onOpenChange={(visible) =>
                                                setPopoverVisible(visible)
                                              }
                                            />
                                          </Text>
                                        </>
                                      )}
                                    </Space> */}
                                  </Row>
                                </Card>
                              )}
                              {obj.attachments.some((attachment) =>
                                attachment.name.includes("Report"),
                              ) && (
                                <Card
                                  size="small"
                                  type="inner"
                                  className="attachmentsCard"
                                  title="Reporting"
                                  styles={{
                                    header: {
                                      background: "#F7FAF2",
                                      padding: "0",
                                    },
                                    body: {
                                      background:
                                        client === "vw"
                                          ? "#D4E2F1BF"
                                          : "#D6E6F8",
                                    },
                                  }}
                                  style={{
                                    fontFamily: `${client}Bold`,
                                    fontSize: "1.111rem",
                                    border: "transparent",
                                    borderRadius: "0",
                                  }}
                                >
                                  <Row gutter={4}>
                                    {obj.attachments
                                      .filter(
                                        (item) =>
                                          item.name.includes("Report") ||
                                          item.name.includes("KBA"),
                                      )
                                      .map((attachment, index) => (
                                        <Col className="gutter-row" span={8}>
                                          <Flex wrap gap="small">
                                            <Typography
                                              style={{
                                                fontFamily: `${client}Regular`,
                                                fontSize: "0.944rem",
                                              }}
                                            >
                                              {attachment.name}
                                            </Typography>
                                            {index === 0 && (
                                              <Popover
                                                overlayInnerStyle={{
                                                  fontFamily: `${client}Regular`,
                                                }}
                                                content={
                                                  <p>
                                                    Overview of tracking
                                                    payloads.
                                                  </p>
                                                }
                                                // title="Popover Title"
                                                trigger="click"
                                                placement="topRight"
                                                overlayStyle={{
                                                  maxWidth: 400,
                                                }}
                                                overlayClassName="tutorialPopover"
                                                open={popoverVisible}
                                                onOpenChange={(visible) =>
                                                  setPopoverVisible(visible)
                                                }
                                              />
                                            )}
                                            <TextArea
                                              value={
                                                attachment.body &&
                                                JSON.stringify(
                                                  JSON.parse(
                                                    atob(attachment.body),
                                                  ),
                                                  null,
                                                  2,
                                                )
                                              }
                                              rows={22}
                                              readOnly
                                              style={{
                                                fontFamily: "monospace",
                                                fontSize: "0.8rem",
                                                backgroundColor:
                                                  "rgb(245 245 245 / 40%) !important",
                                                width: "30vw",
                                              }}
                                            ></TextArea>
                                          </Flex>
                                        </Col>
                                      ))}
                                  </Row>
                                </Card>
                              )}
                            </>
                          ),
                        },
                      ]}
                    ></Collapse>
                    <Divider
                      style={{
                        borderWidth: "1.8px",
                        margin: "0",
                        borderColor: "#000000",
                      }}
                    />
                  </>
                ))}
              </Space>

              <FloatButton
                tooltip="Load Help"
                icon={<FileTextOutlined />}
                description="HELP"
                shape="square"
                className="helpButton"
                onClick={togglePopover}
                style={{
                  fontFamily: `${client}Regular`,
                  insetInlineEnd: 0,
                  top: "80%",
                  transform: "translateY(-50%)",
                  maxHeight: "48px",
                }}
              />
              <FloatButton.BackTop tooltip="Scroll to Top" />
              <Modal
                title="Excluded list"
                onCancel={handleCancel}
                open={isModalOpen}
                footer={null}
                centered={true}
                width={800}
                style={{ fontFamily: `${client}Bold` }}
              >
                <Table
                  columns={columns}
                  dataSource={excludedData}
                  rowKey={(record) => record.actionId}
                  size="small"
                  style={{ fontFamily: `${client}Bold` }}
                  className="excluded-table"
                />
                {/* {excludedData.map((item) => (
                <p>{item.campaign}</p>
              ))} */}
              </Modal>
            </div>
          </Content>
        </Layout>
      </div>
    </div>
  );
};

export default Collection;
